<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')" modal_style="modal-small">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="form-title font-weight-bold">Approve Exam</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <div class="exam-modal-body">
          <div
            v-if="show_feedback"
            class="feedback-block"
            :class="feedback_type === 'success' ? 'success-bg' : 'error-bg'"
          >
            {{ feedback_message }}
          </div>

          <!-- EXAM INFO -->
          <div class="exam-info">
            <div class="avatar">
              <img v-lazy="localImg('Exam.png')" alt="" />
            </div>

            <div class="wrapper">
              <div class="top-text color_text font-weight-700">
                {{ exam_info.title }}
              </div>

              <div class="bottom-text">
                <span class="mr-1">{{ exam_info.class_name }}</span> •
                <span class="mx-1"
                  >{{ exam_info.question_count }} Questions</span
                >
                •
                <span class="ml-1">{{ exam_info.score }} Points</span>
              </div>
            </div>
          </div>

          <!-- INFO TEXT  -->
          <div class="info-text color_text">
            To approve this exam, please set when you want the exam to be
            available to students.
          </div>

          <!-- FORM AREA  -->
          <div class="form-area">
            <div class="form-column">
              <div class="title-text">Exam Open Date</div>
              <input
                v-model="open_date"
                :min="getTodayDate"
                type="datetime-local"
                class="form-control"
              />
            </div>

            <div class="form-column">
              <div class="title-text">Exam Close Date</div>
              <input
                v-model="close_date"
                :min="getTodayDate"
                type="datetime-local"
                class="form-control"
              />
            </div>
            <label class="duration-label">Exam Duration (minutes)</label>
            <div class="position-relative w-100 duration-wrapper">
              <input
                type="text"
                class="form-control fixed-input"
                v-model="duration"
              />
              <div class="time-format">
                <span class="mx-auto">MIN</span>
              </div>
            </div>
          </div>

          <!-- FORM AREA  -->
          <!-- <div class="form-area">
            <div class="form-column">
              <div class="title-text">Exam Close Date</div>
              <input type="datetime-local" class="form-control" />
            </div>

            <div class="form-column">
              <div class="title-text">Exam Close Time</div>
              <input type="time" class="form-control" />
            </div>
          </div> -->

          <!-- BUTTON ROW -->
          <div class="btn-row font-weight-700">
            <button
              class="btn bg-transparent z-depth-0 brand_navy mr-2"
              @click="$emit('closeTriggered')"
            >
              Cancel
            </button>

            <button class="btn btn-accent mx-0" @click="approveExam">
              <span v-if="!approving">Approve Questions</span>
              <span
                v-if="approving"
                class="icon icon-dotted-spinner animate mr-2"
              ></span>
              <span v-if="approving" class="">Approving</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Modal from "@/components/globalComps/Modal";

export default {
  name: "ExamApproveModal",

  components: {
    Modal,
  },

  props: {
    exam_info: Object,
  },

  computed: {
    ...mapGetters(["getCurrentPendingExam"]),

    getAssessmentDuration() {
      let sum = 0;
      if (!this.getCurrentPendingExam) return sum;
      this.getCurrentPendingExam.questions.forEach(({ duration }) => {
        sum += Number(duration);
      });
      return sum;
    },

    getDurationInMinutes() {
      let minutes = this.getAssessmentDuration / 60;
      return Math.ceil(minutes);
    },

    getNewOpenDate() {
      let open_date = new Date(this.open_date);
      let date_string = open_date.toISOString();
      // let date = date_string.substring(0, 10);
      // let time = date_string.substring(11, 19);
      return date_string;
    },

    getNewCloseDate() {
      let close_date = new Date(this.close_date);
      let date_string = close_date.toISOString();
      // let date = date_string.substring(0, 10);
      // let time = date_string.substring(11, 19);
      return date_string;
    },

    getTodayDate() {
      return new Date().toISOString().substring(0, 16);
    },

    approvalPayload() {
      return {
        status: {
          status: 1,
          close_date: this.getNewCloseDate,
          open_date: this.getNewOpenDate,
          duration: Number(this.duration),
          can_start: 1,
          can_see_score: 1,
          can_see_answer: 1,
        },
        exam_id: this.exam_info.id,
      };
    },
  },

  watch: {
    getDurationInMinutes: {
      handler(value) {
        this.duration = value;
      },
      immediate: true,
    },
  },

  data() {
    return {
      duration: "",
      open_date: new Date(this.exam_info.open_date)
        .toISOString()
        .substring(0, 16),

      close_date: new Date(this.exam_info.close_date)
        .toISOString()
        .substring(0, 16),

      approving: false,
      show_feedback: false,
      feedback_type: "",
      feedback_message: "",
    };
  },

  methods: {
    ...mapActions(["approveOrDeclineExam"]),

    showFeedback(type, message, delay = 800) {
      this.feedback_type = type;
      this.show_feedback = true;
      this.feedback_message = message;

      setTimeout(() => {
        this.clearFeedback();
        if (type === "success") this.$router.push({ name: "SchoolDashboard" });
      }, delay);
    },

    clearFeedback() {
      this.feedback_type = "";
      this.feedback_message = "";
      this.show_feedback = false;
    },

    validateDates() {
      if (!this.open_date)
        this.showFeedback("error", "Please set exam open date", 1500);
      if (!this.close_date)
        this.showFeedback("error", "Please set exam close date", 1500);
      return this.open_date && this.close_date ? true : false;
    },

    approveExam() {
      if (!this.validateDates()) return;

      this.approving = true;
      this.approveOrDeclineExam(this.approvalPayload)
        .then(({ code }) => {
          this.approving = false;
          if (code === 200) {
            this.showFeedback("success", "Exam successfully approved");
          } else this.showFeedback("error", "Failed to approve Exam", 1200);
        })
        .catch((err) => {
          console.log("error approving this exam", err);
          this.approving = false;
          this.showFeedback("error", "Error approving Exam", 1200);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-title {
  font-size: 16px;
}

.exam-modal-body {
  .exam-info {
    @include flex_row_start_nowrap;
    margin-bottom: 23px;

    .avatar {
      margin-right: 15px;
      @include equal_min_edge(48);
      border-radius: 10px;
      background: $brand_red_light;

      img {
        @include transform_center;
        @include equal_min_edge(25);
      }
    }

    .top-text {
      font-size: 15.5px;
      line-height: 22px;
      margin-bottom: 4.5px;
    }

    .bottom-text {
      font-size: 14px;
      line-height: 19px;
    }
  }

  .info-text {
    margin-bottom: 20px;
    font-size: 14.75px;
    line-height: 165%;
  }

  .form-area {
    @include flex_row_between_wrap;
    margin-bottom: 30px;

    .form-column {
      width: 48%;

      .title-text {
        font-size: 13px;
        line-height: 16px;
        margin-bottom: 7px;
        font-weight: 700;
      }
    }
  }

  .btn-row {
    @include flex_row_end_nowrap;

    .btn {
      font-size: 11.5px;
      padding: 14px 32px !important;
    }
  }
}

.success-bg {
  border: 1px solid rgba(15, 168, 48, 0.5);
  background: rgba(rgb(108, 230, 169), 0.4);
  color: darken(rgb(6, 148, 82), 5%);
}

.error-bg {
  border: 1px solid lighten($brand_red, 15%);
  background: rgba($brand_red_light, 0.4);
  color: darken($brand_red, 5%);
}

.feedback-block {
  padding: 15px;
  border-radius: 10px;
  font-size: 0.85rem;
  text-align: center;
  margin-bottom: 25px;
}

.duration-wrapper {
  min-height: 2.6rem;
  border-radius: 0.4rem;

  .form-control {
    min-height: 2.5rem;
    border-radius: inherit;
  }
}

.time-format {
  font-size: 0.7rem;
  width: 50px;
  height: 2.4rem;
  top: 1px;
  color: #9c9c9c;
  background-color: #f5f5f5;
  border-radius: 0.4rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: auto;
  text-align: center;
  font-weight: 600;
  position: absolute;
  left: calc(100% - 50.5px);
  z-index: 3;
  display: flex;
  align-items: center;
}

.fixed-input {
  position: absolute;
}

.duration-label {
  font-size: 0.85rem;
  color: #212529;
  font-weight: 600;
  margin: 20px 0 8px 0;
}
</style>
